module.exports = __webpack_public_path__ + "static/media/05.c5bedc3a.png";